import "./App.css";
import "./App.scss";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Layout from "./components/layout";
import WorkWithUsPage from "./pages/WorkWithUsPage";
import AboutPage from "./pages/AboutPage";
import TargetedBuyPage from "./pages/TargetedBuyPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import "react-image-gallery/styles/scss/image-gallery.scss";
import BrandsPage from "./pages/BrandsPage";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "swiper/css/effect-cube";
import BrandsDetailPage from "./pages/BrandsDetailPage";
import ContactUsPage from "./pages/ContactUsPage";
import ProductDesc from "./pages/ProductDesc";
import PayLaterPage from "./pages/PayLaterPage";
import Blogs from "./pages/Blogs";
import BlogsDetail from "./pages/BlogsDetail";
import ComparePage from "./pages/ComparePage";
import "react-toastify/dist/ReactToastify.css";
import Chat from "./components/layout/Chat";
import { initiateSocketConnection } from "./helpers/socketHelper";
import { useEffect, useState, use, createContext } from "react";
import { MOBILE_ROUTES } from "./routes/mobile";
import { DESKTOP_ROUTES } from "./routes/desktop";
import { ProductContext } from "./context/ProductContext";
import { FilterContext } from "./context/FilterContext";
import { Modal } from "@mui/material";
import ModalAccept from "./components/common/ModalAccept";
import Loading from "./components/common/Loading";
import { ExpertContext } from "./context/ExpertContext";
import { DealerDataContext } from "./context/DealerDataContext";
import { httpReauest } from "./utils/httpRequest";

initiateSocketConnection();

function App() {
  const [show, setShow] = useState(false);

  const publicVapidKey =
    "BOpDGrfw-PW0zKvHJ5z2FhrxX3KyZi-lOWbEgCrhPYAPonF8qBvrAbHVT6EkUM_ad0ncMmIpBcS8HdaF-I0fTVk";

  function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  async function readyService() {
    const register = await navigator?.serviceWorker.register("/worker.js", {
      scope: ".",
    });
  }

  async function send() {
    // Register Service Worker

    const register = await navigator?.serviceWorker.register("/worker.js", {
      scope: ".",
    });
    // Register Push
    const subscription = await register?.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
    });

    // Send Push Notification

    await fetch("https://api.1924.ir/api/notification", {
      method: "POST",
      body: JSON.stringify(subscription),
      headers: {
        "content-type": "application/json",
      },
    });
  }

  function sendAllow() {
    if ("serviceWorker" in navigator) {
      send().catch((err) => console.error(err));
    }
  }

  function installApp() {
    let deferredPrompt;

    window?.addEventListener("beforeinstallprompt", (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      console.log("before", e);
      // Update UI notify the user they can install the PWA
    });

    var buttonInstall = document.getElementById("install");

    buttonInstall?.addEventListener("click", (e) => {
      // Hide the app provided install promotion
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
      });
    });
  }

  useEffect(() => {
    installApp();
    readyService();

    let instaled = false;
    let allow = false;

    window.addEventListener("load", () => {
      if (
        navigator?.standalone ||
        window.matchMedia("(display-mode: standalone)").matches
      ) {
        console.log("PWA is installed");
        instaled = true;
      } else {
        console.log("PWA is not installed");
      }
    });

    if (window.Notification) {
      if (window.Notification.permission === "granted") {
        console.log("Notification permission granted");
        allow = true;
        // اینجا می‌توانید کد ارسال نوتیفیکیشن را قرار دهید
      } else if (window.Notification.permission === "denied") {
        console.log("Notification permission denied");
      } else {
        console.log("Notification permission default");
      }
    }

    setTimeout(() => {
      if (!instaled && !allow) {
        const firstone = localStorage.getItem("dontShow");
        const hoursToAdd = 1 * 60 * 60 * 1000;
        if (firstone) {
          const hour = new Date(new Date(firstone).getTime() + hoursToAdd);
          if (new Date().getTime() >= hour.getTime()) {
            setShow(true);
          }
        } else {
          setShow(true);
        }
      }
    }, 2000);

    // Check for service worker

    // Register SW, Register Push, Send Push
  }, []);

  const [moblie, setMobile] = useState(false);
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleResize = () => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    if (window.innerWidth < 1024) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
    if (window.innerWidth < 1024) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    getData();
  }, []);

  const router = createBrowserRouter(moblie ? MOBILE_ROUTES : DESKTOP_ROUTES);

  const [selectProduct, setselectProduct] = useState();

  //filterValues
  const [filter_category, setfilter_category] = useState("");
  const [filter_year_start, setfilter_year_start] = useState("");
  const [filter_year_end, setfilter_year_end] = useState("");
  const [filter_min_price, setfilter_min_price] = useState("");
  const [filter_max_price, setfilter_max_price] = useState("");
  const [filter_min_tonaj, setfilter_min_tonaj] = useState("");
  const [filter_max_tonaj, setfilter_max_tonaj] = useState("");
  const [filter_haveImg, setfilter_haveImg] = useState("");
  const [filter_onFire, setfilter_onFire] = useState("");
  const [filter_search_key, setfilter_search_key] = useState("");
  const [filter_search_type, setfilter_search_type] = useState("product");
  const [filter_brand, setfilter_brand] = useState("");
  const [filter_lazing, setfilter_lazing] = useState("");
  const [sort, setsort] = useState("-createdAt");

  // useEffect(() => {
  //   setTimeout(() => {
  //     document.getElementById("loader").style.display = "none";
  //   }, 1000);
  // }, []);

  async function getData() {
    await httpReauest("GET", `/data`, {}, {}).then(({ data }) => {
      setdealerData(data?.data[0]);
    });
  }

  const [expertUser, setexpertUser] = useState();
  const [dealerData, setdealerData] = useState();

  return (
    <>
      <FilterContext.Provider
        value={{
          filter_category,
          setfilter_category,
          filter_year_start,
          setfilter_year_start,
          filter_year_end,
          setfilter_year_end,
          filter_min_price,
          setfilter_min_price,
          filter_max_price,
          setfilter_max_price,
          filter_haveImg,
          setfilter_haveImg,
          filter_onFire,
          setfilter_onFire,
          filter_search_key,
          setfilter_search_key,
          filter_brand,
          setfilter_brand,
          filter_lazing,
          setfilter_lazing,
          filter_search_type,
          setfilter_search_type,
          filter_min_tonaj,
          setfilter_min_tonaj,
          filter_max_tonaj,
          setfilter_max_tonaj,
          sort,
          setsort,
        }}
      >
        <DealerDataContext.Provider value={{ dealerData, setdealerData }}>
          <ProductContext.Provider value={{ selectProduct, setselectProduct }}>
            <ExpertContext.Provider value={{ expertUser, setexpertUser }}>
              <ModalAccept
                send={sendAllow}
                open={show}
                handleClose={() => setShow(false)}
              />
              <RouterProvider router={router} />
            </ExpertContext.Provider>
          </ProductContext.Provider>
        </DealerDataContext.Provider>
      </FilterContext.Provider>
    </>
  );
}

export default App;
